<div class="faq">
  <div class="row">
    <div class="column twelve md-ten">
      <h2 class="heading-sub-page"><ng-content select="[header]"></ng-content></h2>
      <ng-content select="[questions]"></ng-content>
    </div>
  </div>
</div>
